/**
 * Turns an ad server enum name into something readable — `MAC_OS` reads as
 * "Mac OS", `DESKTOP` as "Desktop". Acronyms of three letters or fewer are
 * left upper-case so OS, PC and IOS do not come back title-cased.
 */
export function enumLabel(value: string): string {
  return value
    .split('_')
    .map((word) =>
      word.length <= 3 && word === word.toUpperCase()
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ')
}
